import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const previousOtherAllowanceSlice = createSlice({
  name: "previousOtherAllowance",

  initialState: {
    previousOtherAllowance: [],
  },
  reducers: {
    setPreviousEmployeeOtherAllowance: (
      state: any,
      action: PayloadAction<any>
    ) => {
      const payload = action.payload;
      state.previousOtherAllowance = payload;
    },

    resetPreviousEmployeeOtherAllowance: (state: any) => {
      state = [];
    },
  },
});

export const {
  resetPreviousEmployeeOtherAllowance,
  setPreviousEmployeeOtherAllowance,
} = previousOtherAllowanceSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default previousOtherAllowanceSlice.reducer;
